<div class="container-fluid filtros-definidos-page">
  <div class="page-header">
    <div class="page-header-row">
      <div class="page-header-texto">
        <h2>Filtros definidos</h2>
        <p>Selecione os campos das abas alinhados ao cadastro do cliente (serviços). Os filtros são gravados no servidor e podem ser escolhidos na tela inicial (gestão).</p>
      </div>
      <button type="button" class="btn btn-outline-secondary btn-voltar" (click)="voltar()">
        <i class="fas fa-arrow-left" aria-hidden="true"></i>
        Voltar
      </button>
    </div>
  </div>

  <div class="card-filtro card-topo">
    <div class="alert-edicao" *ngIf="modoEdicao">
      <span>Editando o filtro <strong>{{ tituloFiltro || '(sem título)' }}</strong>. Altere os campos abaixo e clique em «Salvar alterações», ou cancele.</span>
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="cancelarEdicao()">Cancelar edição</button>
    </div>
    <div class="titulo-salvar-row">
      <div class="titulo-filtro-group">
        <label for="tituloFiltro">{{ modoEdicao ? 'Título do filtro (edição)' : 'Título do filtro' }}</label>
        <input
          id="tituloFiltro"
          type="text"
          class="form-control"
          [(ngModel)]="tituloFiltro"
          placeholder="Ex.: Meu filtro comercial">
      </div>
      <div class="acoes-salvar-grupo">
        <button
          type="button"
          class="btn btn-outline-secondary btn-salvar-filtro"
          *ngIf="modoEdicao"
          (click)="cancelarEdicao()">
          Novo filtro
        </button>
        <button
          type="button"
          class="btn btn-primary btn-salvar-filtro"
          (click)="salvarFiltro()"
          [title]="modoEdicao ? 'Gravar alterações no servidor' : 'Criar filtro no servidor'">
          {{ modoEdicao ? 'Salvar alterações' : 'Salvar filtro' }}
        </button>
      </div>
    </div>
    <div class="filtros-salvos-toolbar" *ngIf="filtrosSalvos.length > 0">
      <span class="filtros-salvos-resumo-texto">{{ filtrosSalvos.length }} filtro(s) salvo(s) no servidor</span>
      <button
        type="button"
        class="btn btn-outline-primary filtros-salvos-abrir-modal"
        (click)="abrirModalListaFiltros(modalListaFiltros)">
        Gerenciar filtros
      </button>
    </div>
    <p class="filtros-salvos-vazio-hint text-muted small mb-0" *ngIf="filtrosSalvos.length === 0">
      Nenhum filtro salvo ainda. Defina o título, marque os campos abaixo e clique em «Salvar filtro».
    </p>
  </div>

  <ng-template #modalListaFiltros>
    <div class="modal-header">
      <h4 class="modal-title">Filtros salvos</h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Fechar"
        (click)="fecharModalListaFiltros()"></button>
    </div>
    <div class="modal-body modal-lista-filtros-body">
      <div class="busca-modal-filtros mb-3">
        <label class="form-label visually-hidden" for="buscaListaFiltros">Buscar por título</label>
        <input
          id="buscaListaFiltros"
          type="text"
          class="form-control"
          [(ngModel)]="termoBuscaListaSalvos"
          placeholder="Buscar filtro pelo título..." />
      </div>
      <ul class="modal-filtros-lista list-unstyled mb-0">
        <li
          *ngFor="let f of filtrosSalvosFiltradosModal"
          class="modal-filtro-linha"
          [class.modal-filtro-linha-ativa]="idFiltroEdicao === f.id">
          <div class="modal-filtro-info">
            <strong>{{ f.titulo }}</strong>
            <span class="text-muted small">
              {{ f.itens.length }} campo(s)
              <ng-container *ngIf="textoQtdCondicoesFiltro(f) as qtdCond">
                · {{ qtdCond }}
              </ng-container>
            </span>
          </div>
          <div class="modal-filtro-acoes">
            <button
              type="button"
              class="btn btn-sm btn-outline-primary"
              (click)="editarFiltroAPartirDoModal(f)">
              Editar
            </button>
            <button
              type="button"
              class="btn btn-sm btn-outline-danger"
              (click)="excluirFiltroSalvo(f.id, $event)">
              Excluir
            </button>
          </div>
        </li>
      </ul>
      <p *ngIf="filtrosSalvosFiltradosModal.length === 0" class="text-muted text-center py-3 mb-0">
        Nenhum filtro encontrado para o termo informado.
      </p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="fecharModalListaFiltros()">Fechar</button>
    </div>
  </ng-template>

  <div class="card-filtro card-filtro-registros">
    <div class="card-header">
      <div>
        <h3>Filtro de registros</h3>
        <p class="filtro-registros-subtitulo mb-0">Restringe quais clientes aparecem na gestão ao usar este filtro.</p>
      </div>
    </div>

    <div class="filtro-registros-modo" *ngIf="podeConfigurarFiltroRegistros; else semColunasParaFiltro">
      <div class="modo-filtro-opcoes" role="radiogroup" aria-label="Modo do filtro de registros">
        <label class="modo-filtro-card" [class.modo-filtro-card--ativo]="filtroRegistros.mostrarTodos">
          <input
            type="radio"
            name="modoFiltroRegistros"
            [checked]="filtroRegistros.mostrarTodos"
            (change)="definirModoFiltroRegistros(true)">
          <span class="modo-filtro-titulo">Todos os registros</span>
          <span class="modo-filtro-desc">Exibe todos os clientes das colunas selecionadas.</span>
        </label>
        <label class="modo-filtro-card" [class.modo-filtro-card--ativo]="filtroRegistrosAtivo">
          <input
            type="radio"
            name="modoFiltroRegistros"
            [checked]="filtroRegistrosAtivo"
            (change)="definirModoFiltroRegistros(false)">
          <span class="modo-filtro-titulo">Apenas com condições</span>
          <span class="modo-filtro-desc">Exibe só quem atender às regras abaixo.</span>
        </label>
      </div>

      <div class="condicoes-filtro-builder" *ngIf="filtroRegistrosAtivo">
        <p class="condicoes-builder-dica">
          <i class="fas fa-info-circle" aria-hidden="true"></i>
          Combine colunas, operadores e valores. Em datas, use <code>[Hoje]</code> para a data atual.
        </p>

        <ng-container *ngFor="let condicao of filtroRegistros.condicoes; let i = index; trackBy: trackByCondicaoIndex">
          <div class="condicao-conector-wrap" *ngIf="i > 0">
            <span class="condicao-conector-linha" aria-hidden="true"></span>
            <div class="condicao-conector-grupo" role="group" [attr.aria-label]="'Ligação entre condição ' + i + ' e ' + (i + 1)">
              <button
                type="button"
                class="condicao-conector-btn"
                [class.condicao-conector-btn--ativo]="condicao.conector === 'e'"
                (click)="definirConectorCondicao(i, 'e')">
                E
              </button>
              <button
                type="button"
                class="condicao-conector-btn"
                [class.condicao-conector-btn--ativo]="condicao.conector === 'ou'"
                (click)="definirConectorCondicao(i, 'ou')">
                OU
              </button>
            </div>
            <span class="condicao-conector-linha" aria-hidden="true"></span>
          </div>

          <article class="condicao-card">
            <header class="condicao-card-header">
              <span class="condicao-card-numero">Condição {{ i + 1 }}</span>
              <button
                type="button"
                class="condicao-card-remover"
                title="Remover condição"
                [disabled]="filtroRegistros.condicoes.length <= 1"
                (click)="removerCondicaoFiltro(i)">
                <i class="fas fa-trash-alt" aria-hidden="true"></i>
                <span>Remover</span>
              </button>
            </header>

            <div class="condicao-card-campos">
              <div class="condicao-field">
                <label [for]="'condCol_' + i">Coluna</label>
                <select
                  class="form-control form-control-sm"
                  [id]="'condCol_' + i"
                  [ngModel]="obterRefCampoSelecionado({ abaId: condicao.abaId, abaTitulo: '', key: condicao.key, label: '' })"
                  (ngModelChange)="aoAlterarColunaCondicao(i, $event)">
                  <option value="">Selecione…</option>
                  <option
                    *ngFor="let col of itensSelecionados"
                    [value]="obterRefCampoSelecionado(col)">
                    {{ col.label }} — {{ col.abaTitulo }}
                  </option>
                </select>
              </div>

              <div class="condicao-field">
                <label [for]="'condOp_' + i">Operador</label>
                <select
                  class="form-control form-control-sm"
                  [id]="'condOp_' + i"
                  [(ngModel)]="condicao.operador">
                  <option *ngFor="let op of obterOperadoresCondicao(condicao)" [value]="op.id">
                    {{ op.label }}
                  </option>
                </select>
              </div>

              <div class="condicao-field condicao-field--valor" *ngIf="operadorCondicaoExigeValor(condicao); else semValorCondicao">
                <label [for]="'condVal_' + i">Valor</label>
                <input
                  class="form-control form-control-sm"
                  [id]="'condVal_' + i"
                  type="text"
                  [(ngModel)]="condicao.valor"
                  [placeholder]="isCampoDataCondicao(condicao) ? '01/01/2026 ou [Hoje]' : 'Digite o valor'">
              </div>
              <ng-template #semValorCondicao>
                <div class="condicao-field condicao-field--sem-valor">
                  <span class="condicao-sem-valor-aviso">Este operador não exige valor.</span>
                </div>
              </ng-template>
            </div>
          </article>
        </ng-container>

        <button type="button" class="btn btn-outline-primary btn-adicionar-condicao" (click)="adicionarCondicaoFiltro()">
          <i class="fas fa-plus" aria-hidden="true"></i>
          Adicionar condição
        </button>
      </div>
    </div>

    <ng-template #semColunasParaFiltro>
      <div class="filtro-registros-vazio">
        <i class="fas fa-columns" aria-hidden="true"></i>
        <p>Selecione ao menos uma coluna na grade abaixo para configurar o filtro de registros.</p>
      </div>
    </ng-template>
  </div>

  <div class="layout-grid">
    <div class="painel-esquerdo">
      <div class="card-filtro">
        <div class="abas-servicos">
          <button
            type="button"
            *ngFor="let aba of abas"
            class="aba-item"
            [class.active]="aba.id === abaAtivaId"
            (click)="selecionarAba(aba.id)">
            <i [class]="aba.icone"></i>
            <span>{{ aba.titulo }}</span>
          </button>
        </div>
      </div>

      <div class="card-filtro">
        <div class="card-header">
          <h3>Campos da aba {{ abaAtiva.titulo }}</h3>
          <div class="card-header-actions">
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="selecionarTodosDaAbaAtiva()">
              Marcar todos
            </button>
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="limparAbaAtiva()">
              Limpar aba
            </button>
          </div>
        </div>

        <div class="busca-campo">
          <input
            type="text"
            class="form-control"
            [(ngModel)]="termoBusca"
            placeholder="Buscar campo nesta aba...">
        </div>

        <div class="lista-campos">
          <label class="campo-item" *ngFor="let campo of camposAbaAtivaFiltrados">
            <input
              type="checkbox"
              [checked]="isCampoSelecionado(abaAtiva.id, campo.key)"
              (change)="toggleCampo(abaAtiva.id, campo.key)">
            <span>{{ campo.label }}</span>
          </label>

          <div class="sem-campos" *ngIf="camposAbaAtivaFiltrados.length === 0">
            Nenhum campo encontrado para o termo informado.
          </div>
        </div>
      </div>
    </div>

    <div class="painel-direito">
      <div class="card-filtro sticky">
        <div class="card-header">
          <h3>Campos selecionados</h3>
          <span class="badge-total">{{ totalSelecionados }}</span>
        </div>

        <div class="selecionados-lista" *ngIf="itensSelecionados.length > 0; else vazioSelecionados">
          <div class="selecionado-item" *ngFor="let item of itensSelecionados; let i = index">
            <div class="selecionado-info">
              <em class="ordem-badge">{{ i + 1 }}</em>
              <small>{{ item.abaTitulo }}</small>
              <strong>{{ item.label }}</strong>
            </div>
            <div class="selecionado-actions">
              <button
                type="button"
                class="btn-ordem"
                title="Subir"
                [disabled]="i === 0"
                (click)="moverSelecionadoParaCima(i)">
                <i class="fas fa-arrow-up"></i>
              </button>
              <button
                type="button"
                class="btn-ordem"
                title="Descer"
                [disabled]="i === itensSelecionados.length - 1"
                (click)="moverSelecionadoParaBaixo(i)">
                <i class="fas fa-arrow-down"></i>
              </button>
              <button
                type="button"
                class="btn-remover"
                title="Remover"
                (click)="removerSelecionado(item.abaId, item.key)">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <ng-template #vazioSelecionados>
          <div class="sem-selecao">Nenhum campo selecionado ainda.</div>
        </ng-template>

        <div class="footer-actions">
          <button type="button" class="btn btn-outline-secondary w-100" (click)="limparSelecionados()">
            Limpar tudo
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

